export const selectSubscription = state => state.subscription;

export const selectPackages = state => selectSubscription(state).packages;

export const selectPackagesFromParentApp = state =>
	selectSubscription(state).packagesFromParentApp;
